import React, { useState } from 'react'
 
 
import GoodsDiscardList from './GoodsDiscardList';
import GoodsDiscardForm from './GoodsDiscardForm';

const GoodsDiscard= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <GoodsDiscardForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <GoodsDiscardList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}  
    </>
  )
}

export default GoodsDiscard